import { cookieBannerAcknowledged } from '@web-platform/shared-universal-redux/src/actions/user';
import { useDispatch } from 'react-redux';

export const useCookieBannerAcknowledged = () => {
  const dispatch = useDispatch();

  const cookieBannerAcknowledgedClick = () => {
    dispatch(cookieBannerAcknowledged());
  };

  return cookieBannerAcknowledgedClick;
};
